import { Route, Routes as RouterRoutes, Navigate } from "react-router-dom";

import { returnEnvironment } from "../utils";

import { Dashboard } from "../pages/dashboard/Dashboard";
import { Campanha } from "../components/campanhas/Campanha";
import { Campanhas } from "../components/campanhas/Campanhas";
import { ForgotPassword } from "../pages/forgotPassword";
import { CreateNewPassword } from "../pages/createNewPassword";
import { EditUserInfo } from "../pages/editUserInfo";
import { Comunidade } from "../pages/comunidade";
import { Ranking } from "../pages/ranking";
import { RankingDetail } from "../pages/ranking/detail";
import { Learn } from "../pages/learn";
import { PostDetails } from "../pages/postDetails";
import { NewPost } from "../pages/newPost";
import { Gamification } from "../pages/gamification";
import { ManageCommunity } from "../pages/manageCommunity";
import { PostSuccess } from "../pages/postSuccess";
import { Desafios } from "../pages/desafios/desafios";
import { ComoFuncionaFavela } from "../pages/comoFuncionaFavela";
import { ContactFavela } from "../pages/contactFavela";
import { OmniContent as WizardOmniContent } from "../components/OmniContent/wizard";

const environment = returnEnvironment();

const dashboardRoutes = {
    default: [ 
        { path: '*', element: <Navigate to="/" /> },
        { path: "/", element: <Navigate to="/campanhas" /> },
        { path: "/campanhas", element: <Campanhas /> },
        { path: "/campanhas/:id", element: <Campanha /> },
        { path: "/editUserInfo", element: <EditUserInfo /> },
        { path: "/aprenda", element: <Learn /> },
    ],
    wizard: [
        { path: '*', element: <Navigate to="/" /> },
        { path: "/", element: <WizardOmniContent /> },
        { path: "/editUserInfo", element: <EditUserInfo /> },
        { path: "/aprenda", element: <Learn /> },
        { path: "/comunidade/:id", element: <Comunidade /> },
        { path: "/comunidade/:id/ranking", element: <Ranking /> },
        { path: "/ranking/creator", element: <RankingDetail /> },
        { path: "/comunidade/:id/gerenciar/*", element: <ManageCommunity /> },
        { path: "/post/:postId", element: <PostDetails /> },
        { path: "/novoPost/:id", element: <NewPost /> },
        { path: "/gamification", element: <Gamification /> },
        { path: "/desafios", element: <Desafios /> },
        { path: "/manageCommunity", element: <ManageCommunity /> },
        { path: "/post-success/:id", element: <PostSuccess /> },
    ],
    favela: [
        { path: '*', element: <Navigate to="/campanhas" /> },
        { path: "/campanhas", element: <Campanhas /> },
        { path: "/campanhas/:id", element: <Campanha /> },
        { path: "/editUserInfo", element: <EditUserInfo /> },
        { path: "/como-funciona", element: <ComoFuncionaFavela /> },
        { path: "/contato", element: <ContactFavela /> },
    ],
};

export const Routes = () => {
    return (
        <RouterRoutes>
            {dashboardRoutes[environment].map(({ path, element }) => (
                <Route key={path} path={path} element={<Dashboard>{element}</Dashboard>} />
            ))}
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/createNewPassword/*" element={<CreateNewPassword />} >
                <Route path=":pathToken" element={<CreateNewPassword />} />
            </Route>
        </RouterRoutes>
    );
};
